module.exports = __webpack_public_path__ + "img/yun.6f9cfaab.png";